<template>
  <component :is="layout">
    <transition mode="out-in">
      <router-view v-if="serviceAvailable" @layout="layout = $event" />
      <service-unavailable v-else />
    </transition>
    <!--
      TODO
      シーズンコンポーネントのファクトリを作成して、そこで時期に応じて
      作成するコンポーネントを変えるようにすれば良さそう。
      -->
    <snow-fall v-if="enableSeasonFeature" />
  </component>
</template>

<script>
import SnowFall from '@/components/season_feature/SnowFall.vue'
import ServiceUnavailable from '@/components/ServiceUnavailable'

export default {
  components: { ServiceUnavailable, SnowFall },
  data() {
    return {
      layout: 'div',
    }
  },
  computed: {
    serviceAvailable() {
      return this.$store.state.service.available
    },
    enableSeasonFeature() {
      return this.$store.state.preferences.enableSeasonFeature
    },
  },
  watch: {
    serviceAvailable(available) {
      if (!available) {
        this.layout = 'div'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// Router Transition Animation
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
